import { LegScheduleService } from '@approot/widgets/strategy-detail/leg/services/leg-schedule.service';
import { FormGroup } from '@angular/forms';
import { scheduleLegAttributeChange } from '../utilities/leg.utilities';
import { LegHelperService } from './leg-helper.service';
import { Injectable } from '@angular/core';
import { Leg } from '@approot/models';
import {
  barrierTypeValDisablerEnabler,
  lowerBarrierTypeChanges,
  upperBarrierTypeChange
} from '../utilities/barrier-utilities';
import { LegMiscellaneousService } from './leg-miscellaneous.service';

@Injectable({
  providedIn: 'root'
})
export class LegBarrierFormListenersService {
  constructor(
    private legHelperService: LegHelperService,
    private legMiscellaneousService: LegMiscellaneousService,
    private legScheduleService: LegScheduleService
  ) {}

  public barrierListeners(): void {
    const form = this.legHelperService.form;
    const leg = this.legHelperService.leg;
    this.barrierListener(form, leg);
    this.barrierTypeListener(form, leg);
    this.secondBarrierTypeListener(form, leg);
    this.lowerBarrierTypeListener(form, leg);
    this.upperBarrierTypeListener(form, leg);
    this.upperBarrierListener(form, leg);
    this.lowerBarrierListener(form, leg);
    this.rangeLowerBarrierListener(form, leg);
    this.rangeUpperBarrierListener(form, leg);
  }

  public optimizeKoBarrier(form: FormGroup, leg: Leg): void {
    const value = form.get('koBarrier')?.value?.toString().toLowerCase();
    if (
      leg.productType === 'simpleaccumulator' &&
      form.get('koBarrierType')?.value === 'AKO' &&
      value === 'o'
    ) {
      this.legMiscellaneousService.optimize('koBarrier');
    }
  }

  private barrierListener(form: FormGroup, leg: Leg): void {
    [
      'barrier',
      'secondBarrier',
      'lkoUpperBarrier',
      'lkoLowerBarrier',
      'kiBarrier',
      'koBarrier'
    ].forEach(key => {
      this.legHelperService.subSink.sink = form
        .get(key)
        ?.valueChanges.subscribe(_ => {
          scheduleLegAttributeChange(form, leg, key, 'schedule');
          this.legScheduleService.updateScheduleValidity('schedule');
          if (key === 'koBarrier') {
            this.optimizeKoBarrier(form, leg);
          }
        });
    });
  }

  private barrierTypeListener(form: FormGroup, leg: Leg): void {
    const nbGuaranteedSettlements = form.get('nbGuaranteedSettlements');
    const isGuaranteedSettlementLeveraged = form.get(
      'isGuaranteedSettlementLeveraged'
    );
    this.legHelperService.subSink.sink = form
      .get('barrierType')
      ?.valueChanges.subscribe(val => {
        // if none barrierType selected, disable barrier field and mark as valid
        barrierTypeValDisablerEnabler('barrierType', 'barrier', val, form, leg);
      });

    this.legHelperService.subSink.sink = form
      .get('koBarrierType')
      ?.valueChanges.subscribe(val => {
        if (val === 'AKO') {
          nbGuaranteedSettlements?.enable();
          isGuaranteedSettlementLeveraged?.enable();
        } else {
          nbGuaranteedSettlements?.setValue('');
          nbGuaranteedSettlements?.disable();
          isGuaranteedSettlementLeveraged?.disable();
        }
      });
  }

  private secondBarrierTypeListener(form: FormGroup, leg: Leg): void {
    this.legHelperService.subSink.sink = form
      .get('secondBarrierType')
      ?.valueChanges.subscribe(val => {
        barrierTypeValDisablerEnabler(
          'secondBarrierType',
          'secondBarrier',
          val,
          form,
          leg
        );
      });
  }

  private lowerBarrierTypeListener(form: FormGroup, leg: Leg): void {
    this.legHelperService.subSink.sink = form
      .get('lowerBarrierType')
      ?.valueChanges.subscribe(val => {
        lowerBarrierTypeChanges(val, form, leg);
      });
  }

  private upperBarrierTypeListener(form: FormGroup, leg: Leg): void {
    this.legHelperService.subSink.sink = form
      .get('upperBarrierType')
      ?.valueChanges.subscribe(val => {
        upperBarrierTypeChange(val, form, leg);
      });
  }

  private upperBarrierListener(form: FormGroup, leg: Leg): void {
    this.legHelperService.subSink.sink = form
      .get('upperBarrier')
      ?.valueChanges.subscribe(val => {
        scheduleLegAttributeChange(form, leg, 'upperBarrier', 'schedule');
        if (
          leg.productType === 'accumulatorspotsettled' &&
          form.get('upperBarrierType')?.value === 'UpAndOut' &&
          val === 'o'
        ) {
          this.legMiscellaneousService.optimize('upperBarrier');
        }
      });
  }

  private lowerBarrierListener(form: FormGroup, leg: Leg): void {
    this.legHelperService.subSink.sink = form
      .get('lowerBarrier')
      ?.valueChanges.subscribe(val => {
        scheduleLegAttributeChange(form, leg, 'lowerBarrier', 'schedule');
        if (
          leg.productType === 'accumulatorspotsettled' &&
          form.get('lowerBarrierType')?.value === 'DownAndOut' &&
          val === 'o'
        ) {
          this.legMiscellaneousService.optimize('lowerBarrier');
        }
      });
  }

  private rangeLowerBarrierListener(form: FormGroup, leg: Leg): void {
    this.legHelperService.subSink.sink = form
      .get('rangeLowerBarrier')
      ?.valueChanges.subscribe(_ => {
        scheduleLegAttributeChange(form, leg, 'rangeLowerBarrier', 'schedule');
      });
  }

  private rangeUpperBarrierListener(form: FormGroup, leg: Leg): void {
    this.legHelperService.subSink.sink = form
      .get('rangeUpperBarrier')
      ?.valueChanges.subscribe(_ => {
        scheduleLegAttributeChange(form, leg, 'rangeUpperBarrier', 'schedule');
      });
  }
}
